(function() {
  jQuery(function() {
    var $, millisToMinutesAndSeconds;
    $ = jQuery;
    window.wl = window.wl || {};
    millisToMinutesAndSeconds = function(millisec) {
      var hours, minutes, seconds;
      seconds = (millisec / 1000).toFixed(0);
      minutes = Math.floor(seconds / 60);
      hours = "";
      if (minutes > 59) {
        hours = Math.floor(minutes / 60);
        hours = hours >= 10 ? hours : "0" + hours;
        minutes = minutes - (hours * 60);
        minutes = minutes >= 10 ? minutes : "0" + minutes;
      }
      seconds = Math.floor(seconds % 60);
      seconds = seconds >= 10 ? seconds : "0" + seconds;
      if (hours !== "") {
        return hours + ":" + minutes + ":" + seconds;
      }
      return minutes + ":" + seconds;
    };
    window.wl.soundcloud = function() {
      var $document, $scPlayer, $window, footer, pendingSeek, ref, ref1, src, trackPlaying, url;
      $window = $(window);
      $document = $(document);
      $scPlayer = $('[wl-soundcloud-player]');
      src = typeof $scPlayer.attr === "function" ? $scPlayer.attr('src') : void 0;
      url = src != null ? (ref = src.split("?")[1]) != null ? (ref1 = ref.split("&")[0]) != null ? ref1.split("=")[1] : void 0 : void 0 : void 0;
      if (!($scPlayer.length && src && url)) {
        return;
      }
      trackPlaying = false;
      pendingSeek = false;
      footer = {
        $el: $("<div class='wl-soundcloud-footer-player'>"),
        $img: $("<img class='art'>"),
        $play: $("<button class='play'>Play</button>"),
        $band: $("<div class='band'></div>"),
        $track: $("<div class='track'></div>"),
        $position: $("<span class='position-label'></span>"),
        $duration: $("<div class='duration'></div>"),
        $positionBar: $("<div class='position'></div>"),
        $positionBug: $("<span></span>")
      };
      return $.getScript("https://w.soundcloud.com/player/api.js", function() {
        var scWidget;
        scWidget = SC.Widget($scPlayer[0]);
        console.log('url:', url);
        scWidget.bind(SC.Widget.Events.PLAY, function(e) {
          footer.$el.removeClass('paused').addClass('playing');
          trackPlaying = true;
          console.log('load progress', trackPlaying, pendingSeek);
          if (pendingSeek) {
            scWidget.seekTo(pendingSeek);
            return pendingSeek = false;
          }
        });
        scWidget.bind(SC.Widget.Events.PAUSE, function(e) {
          trackPlaying = false;
          return footer.$el.removeClass('playing').addClass('paused');
        });
        scWidget.bind(SC.Widget.Events.PLAY_PROGRESS, function(e) {
          footer.$position.text(millisToMinutesAndSeconds(e.currentPosition));
          return footer.$positionBug.css({
            width: (e.relativePosition * 100) + "%"
          });
        });
        scWidget.bind(SC.Widget.Events.FINISH, function() {
          trackPlaying = false;
          footer.$position.text('0:00');
          return footer.$positionBug.css({
            width: "0"
          });
        });
        return scWidget.bind('ready', function() {
          return scWidget.getCurrentSound(function(data) {
            var bigArt, humanDuration, maxFooterRange, maxTopOffset, minFooterRange, setFooterStartEnd, updateFooterDisplay;
            bigArt = data.artwork_url.replace('-large', '-t300x300');
            humanDuration = millisToMinutesAndSeconds(data.duration);
            console.log('test', data);
            footer.$img.attr('src', bigArt);
            footer.$band.text(data.user.username);
            footer.$track.text(data.title);
            footer.$duration.text(humanDuration);
            footer.$position.text("0:00");
            footer.$el.append(footer.$img, footer.$play, footer.$band, footer.$track, footer.$positionBar.append(footer.$positionBug), footer.$duration, footer.$position);
            $('body').append(footer.$el);
            minFooterRange = null;
            maxFooterRange = null;
            maxTopOffset = null;
            setFooterStartEnd = function() {
              var docHeight, height, topOffset, winHeight;
              topOffset = $scPlayer.offset().top;
              height = $scPlayer.height();
              winHeight = $window.height();
              docHeight = $document.height();
              minFooterRange = topOffset - winHeight;
              maxFooterRange = topOffset + height;
              maxTopOffset = docHeight - winHeight - 6;
              return updateFooterDisplay();
            };
            updateFooterDisplay = function() {
              var scrollTop;
              scrollTop = $window.scrollTop();
              if (((minFooterRange < scrollTop && scrollTop < maxFooterRange)) || (scrollTop > maxTopOffset)) {
                return footer.$el.removeClass('ready');
              } else {
                return footer.$el.addClass('ready');
              }
            };
            $window.on('resize', function(e) {
              return setFooterStartEnd();
            });
            $window.on('scroll', function(e) {
              return window.requestAnimationFrame(updateFooterDisplay);
            });
            setFooterStartEnd();
            footer.$play.on('click', function(e) {
              e.preventDefault();
              return scWidget.toggle();
            });
            footer.$positionBar.on('click', function(e) {
              var fraction, width;
              e.preventDefault();
              width = footer.$positionBar.width();
              fraction = (e.pageX - footer.$positionBar.offset().left) / width;
              return scWidget.seekTo(data.duration * fraction);
            });
            return $('body').on('click', 'a', function(e) {
              var $target, href, humanPos, i, j, msPerUnit, ref2, seek, time;
              $target = $(e.target);
              href = null;
              if ($target.attr('href')) {
                href = $target.attr('href');
              } else {
                $target = $target.parent('[href]');
                if ($target.length) {
                  href = $target.attr('href');
                }
              }
              if (href && href.split(':').length) {
                e.preventDefault();
                history.pushState({}, '', href);
                humanPos = href.substr(1);
                msPerUnit = [1000, 60000, 3600000];
                time = humanPos.split(':');
                time.reverse();
                seek = 0;
                for (i = j = 0, ref2 = time.length; 0 <= ref2 ? j < ref2 : j > ref2; i = 0 <= ref2 ? ++j : --j) {
                  seek += parseInt(time[i]) * msPerUnit[i];
                }
                if (trackPlaying) {
                  return scWidget.seekTo(seek);
                } else {
                  pendingSeek = seek;
                  return scWidget.play();
                }
              }
            });
          });
        });
      });
    };
    return wl.soundcloud();
  });

  jQuery(function() {
    var $;
    $ = jQuery;
    window.wl = window.wl || {};
    function convertToMinimalStyle(selector){

		$(selector).each(function(){
			if($(this).parent().find('input:not([type="checkbox"]):not([type="hidden"]):not(#search-outer input):not(.adminbar-input):not([type="radio"]):not([type="submit"]):not([type="button"]):not([type="date"]):not([type="color"]):not([type="range"]):not([role="button"]):not([role="combobox"]):not(.select2-focusser):not([name="min_price"]):not([name="max_price"])').length == 1 || $(this).parent().find('textarea').length == 1) {
				
				if($(this).parents('.minimal-form-input').length == 0) {

					//if there's a direct input next to label
					
					if($(this).next('input').length == 1) {
		
						$(this).next('input').andSelf().wrapAll('<div class="minimal-form-input"/>');
					} else if($(this).find('.wpcf7-form-control-wrap').length > 0) {
						var $cloneInput = $(this).find('.wpcf7-form-control-wrap');
						$(this).find('.wpcf7-form-control-wrap').remove();
						$cloneInput.insertAfter($(this));
						$(this).parent().wrapInner('<div class="minimal-form-input" />');
					} else {
						//if we need to traverse to parent instead	
						$(this).parent().wrapInner('<div class="minimal-form-input" />');
					}
					$html = $(this).html();
					$(this)[0].innerHTML = '<span class="text"><span class="text-inner">'+$html+'</span></span>';
			
					if($(this).parent().find('textarea').length == 1) $(this).parents('.minimal-form-input').addClass('textarea');
				}
			}

		});

		//for labels that changed that already have minimal form markup - just need to update content
		$(selector).each(function(){
			if($(this).parents('.minimal-form-input').length == 1 && $(this).find('.text').length == 0) {
				
				$html = $(this).html();
				$(this)[0].innerHTML = '<span class="text"><span class="text-inner">'+$html+'</span></span>';
				
			}

		});
	}


	function convertPlaceholders() {
		$('#page-contact-modal form input[placeholder]:not([name="min_price"]):not([name="max_price"]), form textarea[placeholder]').each(function(i){
			if($(this).attr('placeholder').length > 1) {
				var $placeholder = $(this).attr('placeholder');
				var $inputID = ($(this).is('[id]')) ? $(this).attr('id') : 'id-'+i;
				//add placeholder as label if label doesn't already exist
				
				//skip cf7                               //|| $(this).prev('label').length == 1 && $placeholder.length > $(this).prev('label').text().length
				if($(this).parents('.wpcf7-form-control-wrap').length == 0) {
					if($(this).prev('label').length == 0 || $(this).is('textarea')) {
						$('<label for="'+$inputID+'">'+$placeholder+'</label>').insertBefore($(this));
					}
				} else {
					if($(this).parents('.wpcf7-form-control-wrap').find('label').length == 0) {
						$('<label for="'+$inputID+'">'+$placeholder+'</label>').insertBefore($(this).parents('.wpcf7-form-control-wrap '));
					}
				}
				$(this).removeAttr('placeholder');
			}
		});
	}


	;
    return wl.contactModal = function() {
      var $cancelButton, $clickedButton, $modalInner, $modalMid, $modalOuter;
      $modalOuter = false;
      $modalMid = false;
      $modalInner = false;
      $cancelButton = false;
      $clickedButton = false;
      return setTimeout(function() {
        var bindModal, disableButton, enableButton, hideModal, prepModal, showModal;
        prepModal = function(cb) {
          if (sessionStorage.contactModal != null) {
            $modalOuter = $(sessionStorage.contactModal);
            $modalMid = $modalOuter.find('> div');
            $modalInner = $modalMid.find('> div');
            $cancelButton = $modalInner.find('> button');
            return typeof cb === "function" ? cb() : void 0;
          } else {
            $modalOuter = $('<div id="page-contact-modal"></div>');
            $modalMid = $('<div></div>');
            $modalInner = $('<div class="container"></div>');
            $cancelButton = $('<button>close</button>');
            return $modalInner.load('/contact/ #ajax-content-wrap > .container-wrap > .main-content > *', function() {
              $modalInner.append($cancelButton);
              $modalMid.append($modalInner);
              $modalOuter.append($modalMid);
              sessionStorage.contactModal = $modalOuter.prop('outerHTML');
              return typeof cb === "function" ? cb() : void 0;
            });
          }
        };
        bindModal = function(cb) {
          var $form;
          $('body').append($modalOuter);
          convertPlaceholders();
          convertToMinimalStyle("#page-contact-modal label");
          $form = $modalInner.find('form');
          wpcf7.initForm($form);
          $cancelButton.on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            return hideModal();
          });
          $modalOuter.on('click', function(e) {
            e.stopPropagation();
            return hideModal();
          });
          $modalInner.on('click', function(e) {
            return e.stopPropagation();
          });
          return setTimeout(function() {
            return typeof cb === "function" ? cb() : void 0;
          }, 100);
        };
        showModal = function() {
          return $modalOuter.addClass('open');
        };
        hideModal = function() {
          $modalOuter.removeClass('open');
          return enableButton();
        };
        disableButton = function() {
          return $clickedButton.css({
            pointerEvents: 'none',
            opacity: 0.5,
            cursor: 'progress'
          });
        };
        enableButton = function() {
          if ($clickedButton != null) {
            $clickedButton.css({
              pointerEvents: 'auto',
              opacity: 1,
              cursor: 'pointer'
            });
          }
          return $clickedButton = false;
        };
        prepModal(bindModal);
        if (location.pathname !== '/contact') {
          return $('a').each(function() {
            var $this;
            if (this.pathname === '/contact/' || this.pathname === '/contact') {
              $this = $(this);
              return $this.off().on('click', function(e) {
                $clickedButton = $this;
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                if ($modalOuter) {
                  disableButton();
                  return showModal();
                }
              });
            }
          });
        }
      }, 100);
    };
  });

  jQuery(function() {
    var $;
    $ = jQuery;
    window.wl = window.wl || {};
    return wl.footerMailchimp = function() {
      return $(".mailchimp-subscription-form").each(function() {
        var $email, $form;
        $form = $(this);
        $email = $form.find("#mce-EMAIL");
        return $form.on('submit', function(e) {
          e.preventDefault();
          return $.ajax({
            type: "GET",
            url: $form.attr("action"),
            data: $form.serialize(),
            cache: false,
            dataType: "jsonp",
            jsonp: "c",
            contentType: "application/json; charset=utf-8",
            success: function(data) {
              var resultMessage;
              if (data.msg.indexOf(' - ') >= 0) {
                resultMessage = data.msg.substring(data.msg.indexOf(' - ') + 3);
              } else {
                resultMessage = data.msg || "Sorry. Unable to subscribe. Please try again later.";
              }
              if (data.result !== "success") {
                if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
                  resultMessage = "You're already subscribed. Thank you.";
                }
              } else {
                resultMessage = "Thank you! You will need to confirm the subscription in your inbox.";
                $form.trigger('wal-subscribed');
              }
              $form.find("span.wpcf7-not-valid-tip").remove();
              return $email.after("<span class='wpcf7-not-valid-tip'>" + resultMessage + "</span>");
            }
          });
        });
      });
    };
  });

  jQuery(function() {
    var $;
    $ = jQuery;
    window.wl = window.wl || {};
    return wl.episodeScroll = function() {
      var $body, $document, $els, $window, readyForUpdate, rows, setNodes, setNodesTimer, sizeTimeout, updateNodes, winHeight, winWidth;
      $els = $('.wl-podcast-row');
      if (!$els.length) {
        return false;
      }
      $body = $('body');
      $window = $(window);
      $document = $(document);
      winHeight = null;
      winWidth = null;
      sizeTimeout = null;
      readyForUpdate = true;
      rows = [];
      $els.each(function() {
        var $this, row;
        $this = $(this);
        row = {
          $el: $this,
          $num: $this.find('.episode-number'),
          $img: $this.find('.image img'),
          zeroPoint: null
        };
        return rows.push(row);
      });
      setNodesTimer = function() {
        if (sizeTimeout) {
          clearTimeout(sizeTimeout);
        }
        return sizeTimeout = setTimeout(function() {
          return setNodes();
        }, 500);
      };
      setNodes = function() {
        var j, len, row;
        winHeight = $window.height();
        winWidth = $window.width();
        for (j = 0, len = rows.length; j < len; j++) {
          row = rows[j];
          row.zeroPoint = row.$el.offset().top + (row.$el.innerHeight() / 2) - (winHeight / 2);
        }
        return updateNodes(true);
      };
      updateNodes = function(forceUpdate) {
        var imgOffset, j, len, midPoint, numOffset, opacity, results, row;
        midPoint = $window.scrollTop();
        readyForUpdate = true;
        results = [];
        for (j = 0, len = rows.length; j < len; j++) {
          row = rows[j];
          numOffset = parseInt((midPoint - row.zeroPoint) * 0.25);
          imgOffset = -50 + ((midPoint - row.zeroPoint) * 0.02);
          opacity = Math.abs(numOffset) < (winHeight / 6) ? 1 : 0;
          if (opacity) {
            row.$num.css({
              transform: "translateY(" + numOffset + "px)"
            });
            row.$img.css({
              transform: "translate(-50%, " + imgOffset + "%) scale(1.1)"
            });
            results.push(row.$el.css({
              opacity: opacity
            }));
          } else {
            results.push(row.$el.css({
              opacity: 0
            }));
          }
        }
        return results;
      };
      $window.on('resize', function(e) {
        readyForUpdate = false;
        return setNodesTimer();
      });
      $window.on('scroll', function(e) {
        if (readyForUpdate) {
          window.requestAnimationFrame(updateNodes);
          return readyForUpdate = false;
        }
      });
      return setNodesTimer();
    };
  });

  jQuery(function() {
    var $;
    $ = jQuery;
    window.wl = window.wl || {};
    return wl.footerScroll = function() {
      var $body, $document, $els, $footer, $window, readyForUpdate, scrollAllowence, selectors, setNodes, setNodesTimer, sizeTimeout, updateNodes;
      $body = $('body');
      $window = $(window);
      $document = $(document);
      $footer = $('#footer-outer');
      readyForUpdate = true;
      sizeTimeout = null;
      scrollAllowence = 12;
      selectors = ['#footer-widgets svg', '#footer-widgets h4', '#footer-widgets a', '#footer-widgets p', '#footer-widgets input', '#copyright'];
      $els = $(selectors.join(', '));
      setNodesTimer = function() {
        if (sizeTimeout) {
          clearTimeout(sizeTimeout);
        }
        return sizeTimeout = setTimeout(function() {
          return setNodes();
        }, 100);
      };
      setNodes = function() {
        var docHeight, footerHeight, footerOffset, maxOffset, winHeight, winWidth;
        docHeight = $document.height();
        winHeight = $window.height();
        winWidth = $window.width();
        footerHeight = $footer.outerHeight();
        footerOffset = $footer.offset().top;
        maxOffset = docHeight - winHeight;
        $els.each(function() {
          var $this, frombottom, wl;
          $this = $(this);
          $this.css({
            transition: 'opacity 0.4s ease-in-out 0.3s'
          });
          wl = {
            top: $this.offset().top,
            height: $this.outerHeight(),
            displayed: false
          };
          if (!wl.height) {
            return;
          }
          if (winWidth < 1000) {
            wl.showPoint = maxOffset - (docHeight - wl.top - wl.height) - scrollAllowence;
          } else {
            frombottom = footerHeight - (wl.top - footerOffset);
            wl.showPoint = maxOffset - footerHeight + frombottom - scrollAllowence;
          }
          return this.wl = wl;
        });
        return updateNodes(true);
      };
      updateNodes = function(forceUpdate) {
        var rawOffset;
        rawOffset = $window.scrollTop();
        readyForUpdate = true;
        return $els.each(function() {
          var $this, wl;
          wl = this.wl;
          $this = $(this);
          if ((wl != null ? wl.showPoint : void 0) == null) {
            return;
          }
          if (wl.showPoint < rawOffset && ((wl.displayed === false) || forceUpdate)) {
            $this.css({
              opacity: 1
            });
            wl.displayed = true;
          } else if (wl.showPoint > rawOffset && ((wl.displayed === true) || forceUpdate)) {
            $this.css({
              opacity: 0
            });
            wl.displayed = false;
          }
          return true;
        });
      };
      $window.on('resize', function(e) {
        readyForUpdate = false;
        return setNodesTimer();
      });
      $window.on('scroll', function(e) {
        if (readyForUpdate) {
          window.requestAnimationFrame(updateNodes);
          return readyForUpdate = false;
        }
      });
      return setNodesTimer();
    };
  });

  jQuery(function() {
    var $, convertMatrix, decomposeMatrix, deltaTransformPoint;
    $ = jQuery;
    window.wl = window.wl || {};
    deltaTransformPoint = function(matrix, point) {
      var dx, dy;
      dx = point.x * matrix.a + point.y * matrix.c + 0;
      dy = point.x * matrix.b + point.y * matrix.d + 0;
      return {
        x: dx,
        y: dy
      };
    };
    convertMatrix = function(matrixString) {
      var set, vals;
      vals = matrixString.match(/\((.+)\)/i)[1].split(', ');
      set = {
        a: vals[0],
        b: vals[1],
        c: vals[2],
        d: vals[3],
        e: vals[4],
        f: vals[5]
      };
      return set;
    };
    decomposeMatrix = function(matrix) {
      var px, py, set, skewX, skewY;
      px = deltaTransformPoint(matrix, {
        x: 0,
        y: 1
      });
      py = deltaTransformPoint(matrix, {
        x: 1,
        y: 0
      });
      skewX = (180 / Math.PI) * Math.atan2(px.y, px.x) - 90;
      skewY = (180 / Math.PI) * Math.atan2(py.y, py.x);
      set = {
        translateX: matrix.e,
        translateY: matrix.f,
        scaleX: Math.sqrt(matrix.a * matrix.a + matrix.b * matrix.b),
        scaleY: Math.sqrt(matrix.c * matrix.c + matrix.d * matrix.d),
        skewX: skewX,
        skewY: skewY
      };
      return set;
    };
    return wl.homeScroll = function() {
      var $body, $document, $introBlock, $logo, $style, $window, distanceEdgeOffset, maxDistance, maxOffset, mobileLogoMax, mobileLogoMin, mobileLogoScale, readyForUpdate, setMaxOffset, updateStyle;
      $body = $('body');
      $window = $(window);
      $document = $(document);
      $introBlock = $('.main-content h1');
      $logo = $('body.home header#top #logo');
      if ($body.hasClass('home')) {
        $style = $('<style>');
        $body.append($style);
        distanceEdgeOffset = 60;
        maxOffset = 0;
        maxDistance = 0;
        readyForUpdate = true;
        mobileLogoMin = null;
        mobileLogoMax = null;
        mobileLogoScale = null;
        setMaxOffset = function() {
          $style.text("");
          maxOffset = $document.outerHeight() - $window.outerHeight();
          if (wl.isIOS) {
            maxOffset -= 60;
          }
          maxDistance = (($window.outerHeight() - $introBlock.outerHeight()) / 4) - distanceEdgeOffset;
          if ($logo.css('transform') === "none") {
            mobileLogoMin = null;
            mobileLogoMax = null;
            return mobileLogoScale = null;
          } else {
            mobileLogoMin = parseInt($logo.css('margin-top'));
            mobileLogoMax = decomposeMatrix(convertMatrix($logo.css('transform'))).translateY;
            return mobileLogoScale = decomposeMatrix(convertMatrix($logo.css('transform'))).scaleX;
          }
        };
        updateStyle = function() {
          var distance, inversePercent, logoScale, logoTranslate, navDisplay, navOpacity, navTranslate, percent, rawOffset, welcomeOpacity;
          rawOffset = $window.scrollTop();
          percent = Math.min(1, Math.max(0, rawOffset / maxOffset));
          inversePercent = 1 - percent;
          distance = maxDistance * percent;
          readyForUpdate = true;
          if (mobileLogoMax) {
            welcomeOpacity = Math.min(1, Math.max(0, (inversePercent * 5) - 4));
            console.log('foo?', mobileLogoMax, mobileLogoMin);
            logoTranslate = ((mobileLogoMax - mobileLogoMin) * inversePercent) + mobileLogoMin;
            logoScale = ((mobileLogoScale - 1) * inversePercent) + 1;
            navOpacity = Math.min(1, Math.max(0, ((percent * 5) - 4) + .05));
            navDisplay = navOpacity > .1 ? 'block' : 'none';
            navTranslate = Math.min(3, Math.max(0, 12 * inversePercent));
            return $style.text("h1 { opacity: " + percent + " !important; } body.home #page-header-bg.fullscreen-header:before { opacity: " + percent + "; } body.home a[href='#welcome'] { opacity: " + welcomeOpacity + " !important; } body.home header#top #logo { margin-top: 0 !important; transform: translateY(" + logoTranslate + "px) scale(" + logoScale + ") !important; } body.home #menu-mobile-secondary-nav { opacity: " + navOpacity + "; display: " + navDisplay + " }");
          } else {
            welcomeOpacity = Math.min(1, Math.max(0, (inversePercent * 5) - 4));
            return $style.text("h1 { opacity: " + percent + " !important; } body.home a[href='#welcome'] { opacity: " + welcomeOpacity + " !important; } body.home #page-header-bg:before { opacity: " + percent + "; } body.home header#top nav>ul li:nth-child(1) a { transform: translateY(" + distance + "px) !important; }");
          }
        };
        $window.on('resize', function(e) {
          setMaxOffset();
          return updateStyle();
        });
        $window.on('scroll', function(e) {
          if (readyForUpdate) {
            window.requestAnimationFrame(updateStyle);
            return readyForUpdate = false;
          }
        });
        setMaxOffset();
        return updateStyle();
      }
    };
  });

  jQuery(function() {
    var $;
    $ = jQuery;
    window.wl = window.wl || {};
    return wl.podcastForms = function() {
      var $contactPanel, $links, $nav, $newsletterPanel, $openPanel, $panels, closeAll, togglePanel;
      $nav = $('body.page-podcast #sidebar .widget_nav_menu');
      $links = $nav.find('a');
      $panels = $('body.page-podcast #sidebar .widget_text');
      $openPanel = null;
      if ($nav.length && $panels.length) {
        $newsletterPanel = $panels.eq(0);
        $contactPanel = $panels.eq(1);
        togglePanel = function(e, $link, $panel) {
          e.preventDefault;
          e.stopImmediatePropagation();
          if ($panel === $openPanel) {
            return closeAll();
          } else if ($openPanel) {
            $links.removeClass('active');
            $link.addClass('active');
            $openPanel.removeClass('open');
            $panel.addClass('open');
            return $openPanel = $panel;
          } else {
            $link.addClass('active');
            $nav.addClass('form-open');
            $panel.addClass('open');
            return $openPanel = $panel;
          }
        };
        closeAll = function(e) {
          if (e != null) {
            e.preventDefault();
          }
          if (e != null) {
            e.stopImmediatePropagation();
          }
          $links.removeClass('active');
          if ($openPanel != null) {
            $openPanel.removeClass('open');
          }
          $openPanel = null;
          return $nav.removeClass('form-open');
        };
        $nav.find("a[href='#newsletter']").on('click', function(e) {
          return togglePanel(e, $(this), $newsletterPanel);
        });
        $nav.find("a[href='#contact']").on('click', function(e) {
          return togglePanel(e, $(this), $contactPanel);
        });
        $newsletterPanel.on('wal-subscribed', function() {
          var $message;
          $newsletterPanel.find('.wpcf7-response-output, .wpcf7-not-valid-tip').remove();
          $message = $("<div class='message-sent'><span>thanks</span></div>");
          $newsletterPanel.prepend($message);
          return setTimeout(closeAll, 1200);
        });
        wl.podcastContactSent = function() {
          var $message;
          $message = $("<div class='message-sent'><span>sent</span></div>");
          $contactPanel.prepend($message);
          return setTimeout(closeAll, 1200);
        };
        $newsletterPanel.find(".cancel").on('click', closeAll);
        return $contactPanel.find(".cancel").on('click', closeAll);
      }
    };
  });

  jQuery(function() {
    var $;
    $ = jQuery;
    window.wl = window.wl || {};
    return wl.portfolioFooterGrid = function() {
      var $window;
      if ($('body.single-portfolio').length) {
        $window = $(window);
        return $.get("/" + (window.location.pathname.split('/')[1]), function(response) {
          var $header, $pageContent, $portfolio, fadeRange, fadeStart, readyForUpdate, setNodes, setNodesTimer, sizeTimeout, updateNodes;
          $portfolio = $(response).find('#portfolio');
          $pageContent = $(".container.main-content");
          $header = $("#header-outer");
          $portfolio.css({
            paddingTop: '50px'
          });
          $pageContent.parent().append($('<div class="footer-portfolio">').append($('<div class="container">').append($portfolio)));
          $window.trigger('resize');
          sizeTimeout = null;
          readyForUpdate = true;
          fadeStart = null;
          fadeRange = null;
          setNodesTimer = function() {
            if (sizeTimeout) {
              clearTimeout(sizeTimeout);
            }
            return sizeTimeout = setTimeout(function() {
              return setNodes();
            }, 50);
          };
          setNodes = function() {
            fadeRange = $window.height() * 0.8;
            fadeStart = $portfolio.offset().top - ($window.height() * 1.1);
            return updateNodes();
          };
          updateNodes = function() {
            var scrollTop;
            scrollTop = $window.scrollTop();
            readyForUpdate = true;
            if (scrollTop < fadeStart) {
              return $pageContent.css({
                opacity: 1
              });
            } else if (scrollTop > fadeStart + fadeRange) {
              $header.removeClass('invisible');
              return $pageContent.css({
                opacity: 0
              });
            } else {
              return $pageContent.css({
                opacity: 1 - ((scrollTop - fadeStart) / fadeRange)
              });
            }
          };
          $window.on('resize', function(e) {
            readyForUpdate = false;
            return setNodesTimer();
          });
          setInterval(setNodes, 2000);
          return $window.on('scroll', function(e) {
            if (readyForUpdate) {
              window.requestAnimationFrame(updateNodes);
              return readyForUpdate = false;
            }
          });
        });
      }
    };
  });

  jQuery(function() {
    var $;
    $ = jQuery;
    window.wl = window.wl || {};
    return wl.productPage = function() {
      var $itemOffers, $message, $variation, currentContent, handleChanges, onAjaxComplete, openSidecart, originalContent, text;
      if ($('body').hasClass('single-product')) {
        $variation = $('.woocommerce-variation.single_variation');
        $itemOffers = $('.entry-summary [itemprop="offers"]');
        originalContent = $itemOffers.html();
        currentContent = null;
        $variation.css({
          maxHeight: 0,
          overflow: 'hidden'
        });
        handleChanges = function() {
          var currentVariation;
          currentVariation = $variation.css('display') === 'block' ? $variation.html() : originalContent;
          if (currentVariation !== currentContent) {
            $itemOffers.html(currentVariation);
            return currentContent = currentVariation;
          }
        };
        setInterval(handleChanges, 250);
        text = null;
        $message = $('body').find('.woocommerce-message');
        openSidecart = function() {
          var $cartInner, $cartOuter;
          $cartOuter = $('.woocommerce.widget_shopping_cart');
          $cartInner = $('.product_list_widget');
          $cartInner.parent().prepend("<h4>" + text + "</h4>");
          $cartOuter.addClass('open');
          $cartOuter.css({
            display: 'block'
          });
          $cartInner.css({
            display: 'block'
          });
          return console.log('foooo?', text, $cartOuter, $cartInner);
        };
        if ($message.length) {
          $message.find('*').remove();
          text = $message.text();
          $message.remove();
          onAjaxComplete = function() {
            return openSidecart();
          };
          return $('body').one('ajaxComplete', onAjaxComplete);
        }
      }
    };
  });

  window.wl = window.wl || {};

  jQuery(function() {
    var $;
    $ = jQuery;
    wl.isIOS = !!navigator.platform.match(/iPhone|iPod|iPad/);
    if (wl.isIOS) {
      $('body').addClass('isIOS');
    }
    wl.questionFormReveal = function() {
      var close, open;
      open = function(e) {
        e.preventDefault();
        $(this).addClass('hide');
        return $('#question-form').addClass('show');
      };
      close = function(e) {
        e.preventDefault();
        $(this).removeClass('hide');
        return $('#question-form').removeClass('show');
      };
      return $('a[href="#question-form"]').toggle(open, close);
    };
    wl.iosVideoHack = function() {
      var $head, $vid, doIt;
      $vid = $('body.home .nectar-video-wrap video');
      $head = $('#page-header-bg');
      if ($vid.length) {
        doIt = function() {
          if (!$('.nectar-video-wrap video').length) {
            $vid.attr('playsinline', '');
            $vid.attr('webkit-playsinline', '');
            $vid.attr('muted', '');
            $vid[0].addEventListener('progress', function() {
              $vid.css({
                visibility: 'visible'
              });
              return setTimeout(function() {
                return $head.find('.mobile-video-image').css({
                  visibility: 'hidden'
                });
              }, 20);
            }, false);
            return $head.append($vid.parent());
          }
        };
        return setTimeout(doIt, 20);
      }
    };
    wl.journalExcerptGrabber = function() {
      var $articles, maxWords;
      $articles = $("body.blog article.large_featured:not(:first-child)");
      maxWords = 30;
      if ($articles.length) {
        return $articles.each(function() {
          var $this, url;
          $this = $(this);
          url = $this.find('a').attr('href');
          return $.get(url, function(response) {
            var $paragraph, firstParagraph, output, ref, ref1, words;
            firstParagraph = (ref = $(response).find('p')) != null ? (ref1 = ref.first()) != null ? ref1.text() : void 0 : void 0;
            if (firstParagraph.length) {
              words = firstParagraph.split(' ');
              output = words.splice(0, maxWords).join(" ");
              if (words.length > maxWords) {
                output += "...";
              }
              $paragraph = $("<p>" + output + "</p>");
              $paragraph.css({
                opacity: 0,
                transition: "opacity 0.5s ease-in-out"
              });
              $this.find('.post-header').append($paragraph);
              return setTimeout(function() {
                return $paragraph.css({
                  opacity: 1
                });
              }, 250);
            }
          });
        });
      }
    };
    wl.shopCollection = function() {
      var $products;
      $products = $('body.tax-product_cat ul.products li.product');
      if ($products.length) {
        return $products.each(function() {
          var $this;
          $this = $(this);
          return $this.find('h3').after($this.find('.price'));
        });
      }
    };
    wl.removeEmptyCart = function() {
      return setTimeout(function() {
        var $cartIndicator, $cartMenu;
        $cartMenu = $('.cart-menu');
        $cartIndicator = $cartMenu.find('.cart-wrap span');
        if (!(parseInt($cartIndicator.text().trim()) > 0)) {
          return $cartMenu.css({
            display: 'none'
          });
        }
      }, 50);
    };
    wl.biographyList = function() {
      var $bioList, $bios, $innerList, $social, $window, j, len, placeSocial, prevPosition, ref, social;
      $bioList = $('.wl-biography-list');
      $bios = $bioList.find('> li');
      if ($bioList.length && wl.socialList) {
        console.log(wl, wl.socialList);
        $window = $(window);
        prevPosition = null;
        $social = $("<li class='bio-social'> <h3>Follow Us</h3> <div class='wl-social hide-share-count items_" + wl.socialList.length + "'> </div>");
        $innerList = $social.find('.wl-social');
        ref = wl.socialList;
        for (j = 0, len = ref.length; j < len; j++) {
          social = ref[j];
          if (social.url) {
            $innerList.append("<a href='" + social.url + "' title='" + social.name + "' target='_blank'> <i class='fa fa-" + social.name + "'></i> </a>");
          }
        }
        placeSocial = function() {
          var position;
          position = parseInt($bioList.css('text-indent'));
          if (position !== prevPosition) {
            $bios.eq(position).after($social);
            return prevPosition = position;
          }
        };
        $window.on('resize', function(e) {
          return placeSocial();
        });
        return placeSocial();
      }
    };
    wl.homeScroll();
    wl.removeEmptyCart();
    wl.biographyList();
    wl.footerMailchimp();
    wl.contactModal();
    wl.podcastForms();
    wl.episodeScroll();
    wl.iosVideoHack();
    wl.portfolioFooterGrid();
    wl.journalExcerptGrabber();
    wl.shopCollection();
    return wl.productPage();
  });

}).call(this);

//# sourceMappingURL=wedgeandlever.js.map
